var trackingFunc = {
    trackingHash: [],
    get tracking() {
        return this.trackingHash.join('_');
    },
    set tracking(data) {
        if (!data['form']) {
            this.trackingHash = ['st2', (data.registrationRequired ? 'reg' : 'noreg'), (data.isGms ? 'gms' : 'legacy'), data.sku];
        } else if (data.form) {
            this.trackingHash[0] = 'st3';
        } else {
            this.trackingHash = [];
        }
    }
}

var clipboard = new ClipboardJS('.copy-to-clipboard');

$("#activation-form").append('<img src="//static3.avast.com/web/i/ajax-loader.gif" alt="" class="form-ajax-loader padded display-block pull-center" />');
loadActivationForm();

function loadActivationForm() {
    $("#activation-form").load("activation-form", function () {
        initAvastForm();
        $('img.form-ajax-loader').remove();
        $('#activation-form').updateFormInputs();

        var activationCode = getQueryVariable('activation-code');
        if (activationCode !== '') {
            $('input[name=key]').val(activationCode);
        }

        $('#activation-form').on('click', '.changeAction', function () {
            $('#actionStep').val($(this).attr('data-default')).change();
        });
        $('#actionStep').change(function () {
            locationChanged();
        });
    });
}

function locationChanged() {
    var $actionType = $('#actionType'),
        $submitBtn = $('.submit.ajax'),
        btnText = '',
        activateBtnTxt = $submitBtn.data('activate-txt'),
        activateLoginBtnTxt = $submitBtn.data('activate-login-txt'),
        initBtnTxt = $submitBtn.data('init-txt');

    $actionType.val($('#actionStep').val().replace('#', '')).change();
    $('[data-show-element]').addClass('hidden');
    $('[data-show-element~=' + $actionType.val() + ']').removeClass('hidden');

    if ($actionType.val() === 'activateLogin' || $actionType.val() === 'activateLoginRegister') {
        btnText = activateLoginBtnTxt;
        // reset email in create account form in case user switch to login form
        $('#activation-form #frm-email').val('');
    } else if ($actionType.val() === 'analyze') {
        btnText = initBtnTxt;
    } else {
        btnText = activateBtnTxt;
    }
    $submitBtn.val(btnText);
}

function activate(data, form) {
    if (data.errors && data.errors.captcha) {
        loadActivationForm();
    }
    var $errorMsg = $('.error-messages'),
        $actionType = $('#actionType'),
        $actionStep = $('#actionStep'),
        $submitBtn = $('.submit.ajax'),
        $showKey = $('input[name=showKey]'),
        activateBtnTxt = $submitBtn.data('activate-txt'),
        activateLoginBtnTxt = $submitBtn.data('activate-login-txt'),
        initBtnTxt = $submitBtn.data('init-txt'),
        btnText = initBtnTxt,
        action = '',
        gmsAction = '',
        ACTIVE = 'ACTIVE',
        USED = 'USED',
        EXPIRED = 'EXPIRED',
        MIGRATED = 'MIGRATED',
        HIDDEN = 'hidden',
        REGISTER = 'Register';

    // redirect some products to new flow WCS-2796
    if (data.redirect === 'smb') {
        var lang = '';
        if (typeof avastGlobals !== 'undefined' && typeof avastGlobals.web !== 'undefined') {
            lang = '/' + avastGlobals.web.locale;
        }
        window.location.replace('https://www.avg.com' + lang + '/activation-new');
        return;
    }

    if (data.redirect === 'install') {
        var lang = '';
        if (typeof avastGlobals !== 'undefined' && typeof avastGlobals.web !== 'undefined') {
            lang = '/' + avastGlobals.web.lang;
        }
        window.location.replace('https://help.avg.com' + lang + '/install');
        return;
    }

    if (data.errorMessage) {
        $errorMsg.removeClass(HIDDEN);
        $errorMsg.html(data.errorMessage);
        ga('send', 'event', 'Error', '' + data.errorCode + ' - ' + data.errorMessage + '', location.href);
    } else {
        $errorMsg.addClass(HIDDEN);
        $errorMsg.html('');
    }

    if (data.form) {
        $('#activation-form').html(data.form);
        $('.' + platformDetection().replace('_', '-')).toggleClass('button-outlined button-green');
    } else if (data.conflict) {
        $('#forgot-password-form').html(data.conflict);
        $('.conflict').trigger("click");
        $('.conflict').on('click', '.renew', function () {
            $('input[name="force"]').val('true');
            $('.submit').submit();
        });
    } else if (data.renewalKey && data.renewalKey === true) {
        // show only error message WCS-3067
    } else if (data.valid && data.status !== USED && data.status !== ACTIVE && data.status !== EXPIRED && data.status !== MIGRATED) {
        $('.avast-form').addClass('form-step2');
        $('.step1').addClass(HIDDEN);
        $('.step2').removeClass(HIDDEN);
        action = data.registrationRequired ? REGISTER : '';

        if (data.isGms === true) {
            // remove in WCS-5256
        } else {
            $('.legacy').removeClass(HIDDEN); // show text and data for legacy product
            $actionType.val('activate' + action).change();
        }
    }

    $('[data-show-element], .hidden-select').addClass(HIDDEN);
    $('[data-show-element~=' + $actionType.val() + '], .' + $actionType.val()).removeClass(HIDDEN);

    if ($actionType.val() === 'activateLogin' || $actionType.val() === 'activateLoginRegister') {
        btnText = activateLoginBtnTxt;
    } else if ($actionType.val() === 'analyze') {
        btnText = initBtnTxt;
    } else {
        btnText = activateBtnTxt;
    }
    $submitBtn.val(btnText);

    if (data.code) {
        $showKey.val(data.code);
    }

    if (data.sku || data.form) {
        trackingFunc.tracking = data;
        location.hash = trackingFunc.tracking;
        $actionStep.val($actionType.val()).change();
    }
}

$('#activation-form').on('click', '.forgot-password-button', function () {
    $("#forgot-password-form").load("activation-forgot-password-form", function () {
        initAvastForm();
    });
});

function recover(data, form) {
    if (data.form) {
        $('#forgot-password-form').html(data.form);
    }

    if (data.errorMessage) {
        var $errorEl = $('.error-messages');

        $errorEl.html(data.errorMessage);
        $errorEl.removeClass('hidden');
    }
}